// https://stackoverflow.com/a/5040502/259477
// Used to show which mode a report is in
export const Modes = Object.freeze({ Unknown: 'Unknown', Edit: 'Edit', ReadOnly: 'ReadOnly' })
